import React from 'react';
import { Grid } from '@mui/material';
import translations from './activity.psa.i18n';
import * as css from './activity.psa.module.scss';
import { FakeLockedInput } from '../components/input';
import { formatLocaleNo } from '../date.utils';
import { useActivityContextPSA } from './activitycontexts';
import { useFormatMessageFor } from '../i18n/translation';

const ActivityInfo = () => {
  return (
    <div className={css.verticalMargin}>
      <Grid container spacing={3}>
        <PracticePeriod />
      </Grid>
    </div>
  );
};

const PracticePeriod = () => {
  const { praksisaktivitet } = useActivityContextPSA();
  const { startDato, sluttDato, totalBestilling, totalKapasitet } =
    praksisaktivitet;

  const labels = useFormatMessageFor(translations);

  return (
    <>
      <Grid item xs={3}>
        <FakeLockedInput
          label={labels.periodOppstart}
          value={formatLocaleNo(startDato)}
        />
      </Grid>
      <Grid item xs={3}>
        <FakeLockedInput
          label={labels.periodAvslutning}
          value={formatLocaleNo(sluttDato)}
        />
      </Grid>
      <Grid item xs={4} />
      <Grid item xs={2}>
        <FakeLockedInput
          label={labels.periodTotalBestillinger}
          value={totalBestilling.toString()}
        />
      </Grid>
      <Grid item xs={2}>
        <FakeLockedInput
          label={labels.periodTotalKapasiteter}
          value={totalKapasitet.toString()}
        />
      </Grid>
    </>
  );
};

export default ActivityInfo;
